"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/trans-union-ccs-response-context.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Ftrans-union-ccs-response-context.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransUnionCcsResponseErrorServiceProductError = exports.TransUnionCcsResponseErrorBaseError = exports.TransUnionCcsResponseError = exports.TransUnionCcsResponseContext = void 0;
const protobufPackage = 'com.step.creditmonitor.proto';
function createBaseTransUnionCcsResponseContext() {
    return { clientKey: '', requestKey: '', fulfillResponseError: undefined };
}
exports.TransUnionCcsResponseContext = {
    fromJSON(object) {
        const message = {
            clientKey: isSet(object.clientKey) ? globalThis.String(object.clientKey) : '',
            requestKey: isSet(object.requestKey) ? globalThis.String(object.requestKey) : '',
        };
        if (isSet(object.fulfillResponseError)) {
            message.fulfillResponseError = exports.TransUnionCcsResponseError.fromJSON(object.fulfillResponseError);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.clientKey !== '') {
            obj.clientKey = message.clientKey;
        }
        if (message.requestKey !== '') {
            obj.requestKey = message.requestKey;
        }
        if (message.fulfillResponseError !== undefined) {
            obj.fulfillResponseError = exports.TransUnionCcsResponseError.toJSON(message.fulfillResponseError);
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionCcsResponseContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionCcsResponseContext();
        message.clientKey = object.clientKey ?? '';
        message.requestKey = object.requestKey ?? '';
        message.fulfillResponseError =
            (object.fulfillResponseError !== undefined && object.fulfillResponseError !== null)
                ? exports.TransUnionCcsResponseError.fromPartial(object.fulfillResponseError)
                : undefined;
        return message;
    },
};
function createBaseTransUnionCcsResponseError() {
    return {
        baseError: exports.TransUnionCcsResponseErrorBaseError.fromPartial({}),
        serviceProductErrors: [],
    };
}
exports.TransUnionCcsResponseError = {
    fromJSON(object) {
        const message = {
            baseError: isSet(object.baseError)
                ? exports.TransUnionCcsResponseErrorBaseError.fromJSON(object.baseError)
                : exports.TransUnionCcsResponseErrorBaseError.fromPartial({}),
        };
        if (globalThis.Array.isArray(object?.serviceProductErrors)) {
            message.serviceProductErrors = object.serviceProductErrors.map((e) => exports.TransUnionCcsResponseErrorServiceProductError.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.baseError !== undefined) {
            obj.baseError = exports.TransUnionCcsResponseErrorBaseError.toJSON(message.baseError);
        }
        if (message.serviceProductErrors?.length) {
            obj.serviceProductErrors = message.serviceProductErrors.map((e) => exports.TransUnionCcsResponseErrorServiceProductError.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionCcsResponseError.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionCcsResponseError();
        message.baseError = (object.baseError !== undefined && object.baseError !== null)
            ? exports.TransUnionCcsResponseErrorBaseError.fromPartial(object.baseError)
            : exports.TransUnionCcsResponseErrorBaseError.fromPartial({});
        message.serviceProductErrors =
            object.serviceProductErrors?.map((e) => exports.TransUnionCcsResponseErrorServiceProductError.fromPartial(e)) || [];
        return message;
    },
};
function createBaseTransUnionCcsResponseErrorBaseError() {
    return { responseType: '', errorCode: '', errorName: '', errorMessage: '' };
}
exports.TransUnionCcsResponseErrorBaseError = {
    fromJSON(object) {
        const message = {
            responseType: isSet(object.responseType) ? globalThis.String(object.responseType) : '',
        };
        if (isSet(object.errorCode)) {
            message.errorCode = globalThis.String(object.errorCode);
        }
        if (isSet(object.errorName)) {
            message.errorName = globalThis.String(object.errorName);
        }
        if (isSet(object.errorMessage)) {
            message.errorMessage = globalThis.String(object.errorMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.responseType !== '') {
            obj.responseType = message.responseType;
        }
        if (message.errorCode !== undefined && message.errorCode !== '') {
            obj.errorCode = message.errorCode;
        }
        if (message.errorName !== undefined && message.errorName !== '') {
            obj.errorName = message.errorName;
        }
        if (message.errorMessage !== undefined && message.errorMessage !== '') {
            obj.errorMessage = message.errorMessage;
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionCcsResponseErrorBaseError.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionCcsResponseErrorBaseError();
        message.responseType = object.responseType ?? '';
        message.errorCode = object.errorCode ?? '';
        message.errorName = object.errorName ?? '';
        message.errorMessage = object.errorMessage ?? '';
        return message;
    },
};
function createBaseTransUnionCcsResponseErrorServiceProductError() {
    return {
        serviceProduct: '',
        serviceProductType: '',
        responseStatus: '',
        errorCode: '',
        errorName: '',
        errorMessage: '',
    };
}
exports.TransUnionCcsResponseErrorServiceProductError = {
    fromJSON(object) {
        const message = {
            serviceProduct: isSet(object.serviceProduct) ? globalThis.String(object.serviceProduct) : '',
            serviceProductType: isSet(object.serviceProductType)
                ? globalThis.String(object.serviceProductType)
                : '',
        };
        if (isSet(object.responseStatus)) {
            message.responseStatus = globalThis.String(object.responseStatus);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = globalThis.String(object.errorCode);
        }
        if (isSet(object.errorName)) {
            message.errorName = globalThis.String(object.errorName);
        }
        if (isSet(object.errorMessage)) {
            message.errorMessage = globalThis.String(object.errorMessage);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.serviceProduct !== '') {
            obj.serviceProduct = message.serviceProduct;
        }
        if (message.serviceProductType !== '') {
            obj.serviceProductType = message.serviceProductType;
        }
        if (message.responseStatus !== undefined && message.responseStatus !== '') {
            obj.responseStatus = message.responseStatus;
        }
        if (message.errorCode !== undefined && message.errorCode !== '') {
            obj.errorCode = message.errorCode;
        }
        if (message.errorName !== undefined && message.errorName !== '') {
            obj.errorName = message.errorName;
        }
        if (message.errorMessage !== undefined && message.errorMessage !== '') {
            obj.errorMessage = message.errorMessage;
        }
        return obj;
    },
    create(base) {
        return exports.TransUnionCcsResponseErrorServiceProductError.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransUnionCcsResponseErrorServiceProductError();
        message.serviceProduct = object.serviceProduct ?? '';
        message.serviceProductType = object.serviceProductType ?? '';
        message.responseStatus = object.responseStatus ?? '';
        message.errorCode = object.errorCode ?? '';
        message.errorName = object.errorName ?? '';
        message.errorMessage = object.errorMessage ?? '';
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=trans-union-ccs-response-context.js.map